import { render, staticRenderFns } from "./UserSettingsProfile.vue?vue&type=template&id=49a68eec&"
import script from "./UserSettingsProfile.vue?vue&type=script&lang=js&"
export * from "./UserSettingsProfile.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsProfile.vue?vue&type=style&index=0&id=49a68eec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports